import {headers} from '../common'

async function getListData(page, name, sortProp) {
  const params = {
    page: page,
    name: name,
    key: sortProp.key,
    dir: sortProp.dir
  };
  const queryParams = new URLSearchParams(params);

  return fetch('/api/companies?' + queryParams
  ).then(res => {
    return res;
  })
  .catch(errors => {
    return errors;
  })
}

async function getListShopOfCompany(id) {
  return fetch('/api/companies/' + id + '/list-shop'
  ).then(res => {
    return res;
  })
  .catch(errors => {
    return errors;
  })
}

async function getAll() {
  return fetch('/api/companies/all'
  ).then(res => {
    return res;
  })
  .catch(errors => {
    return errors;
  })
}

export { getListData, getListShopOfCompany, getAll }
